import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { HelpersService } from 'src/app/helpers.service'
import { BuilderService } from '../../builder-services/builder.service'
import { LoginService } from '../../login/login.service'
import { AnalyticsApiService } from 'src/app/builder-services/api/analytics.api.service'

@Injectable({
  providedIn: 'root'
})
export class IosbuildService {
  buildingIos = false

  private builderUrl: string

  options = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  }
  token: any

  constructor(
    private http: HttpClient,
    private helper: HelpersService,
    private builderService: BuilderService,
    private loginService: LoginService,
    private analyticsApi: AnalyticsApiService
  ) {
    this.builderUrl = this.helper.getBuilderUrl()
    this.token = this.builderService.getToken()
    this.buildingIos = true
  }

  startBuild = (id: any, version: string, type: string = '') => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('projectId', id)
    postData.set('standalone', this.builderService.standalone ? 'true' : 'false')
    postData.set('version', JSON.stringify(version))
    postData.set('token', this.token)

    // Track iOS build analytics (skip if user is admin)
    this.trackIosBuild(id)

    return this.http.post(this.builderUrl + 'build-ios', postData.toString(), this.options)
  }

  getProgress = (id: any, version: any) => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('projectId', id)
    postData.set('version', JSON.stringify(version))
    postData.set('type', 'ios_status')
    postData.set('token', this.token)

    return this.http.post(this.builderUrl + 'get-build-progress', postData.toString(), this.options)
  }

  getBuildError = (id: any) => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('projectId', id)
    postData.set('token', this.token)
    postData.set('platform', 'ios')

    return this.http.post(this.builderUrl + 'get-build-error', postData.toString(), this.options)
  }

  /**
   * Check if app is published on App Store
   */
  checkAppPublished(bundleId: string, projectId: string) {
    const url = `${this.builderUrl}check-ios-app-published?bundleId=${bundleId}&projectId=${projectId}`
    return this.http.get<{
      isPublished: boolean
      appStoreState: string | null
      bundleId: string
      appName?: string
      error?: string
    }>(url)
  }

  /**
   * Get app versions from App Store Connect
   */
  getAppVersions(bundleId: string, projectId: string) {
    const url = `${this.builderUrl}get-ios-app-versions?bundleId=${bundleId}&projectId=${projectId}`
    return this.http.get<{
      data: Array<{
        id: string
        versionString: string
        appStoreState: string
        platform: string
        createdDate: string
      }>
      liveVersion: {
        id: string
        versionString: string
        appStoreState: string
        platform: string
        createdDate: string
      } | null
      preparingVersion: {
        id: string
        versionString: string
        appStoreState: string
        platform: string
        createdDate: string
      } | null
      bundleId: string
      appName?: string
    }>(url)
  }
  
  /**
   * Tracks iOS build analytics via the stacks-agents creation layer.
   * Skips tracking if the current user is an admin.
   */
  private trackIosBuild(projectId: string): void {
    if (this.loginService.getCurrentUser()?.admin) return
    this.analyticsApi.trackBuild(String(projectId), 'ios')
      .catch((error) => console.error('Error tracking iOS build analytics:', error))
  }
}
